import { Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { StartNewCallAction } from 'src/app/store/samwin/client-phone/client-phone.actions';
import { ConversationTypeRemoteDto } from 'src/generated/signalR/conversation-type-remote-dto';
import { CallHistoryEntryRemoteDto } from 'src/generated/swagger';

@Component({
   selector: 'samweb-call-history-for-agent',
   templateUrl: './call-history-for-agent.component.html',
   styleUrls: ['./call-history-for-agent.component.scss'],
})
export class CallHistoryForAgentComponent {
   @Input()
   callHistory: CallHistoryEntryRemoteDto[];

   constructor(private store: Store) {}

   public callHistroy(numberToCall: any) {
      this.store.dispatch(new StartNewCallAction(numberToCall.toString()));
   }

   public isCall(conversationType: ConversationTypeRemoteDto) {
      return conversationType === ConversationTypeRemoteDto.Call;
   }
}
